import { render, staticRenderFns } from "./clearTime.vue?vue&type=template&id=6a20983d&scoped=true&"
import script from "./clearTime.vue?vue&type=script&lang=js&"
export * from "./clearTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20983d",
  null
  
)

export default component.exports